import React, { useLayoutEffect } from "react";
import ReactDOM from "react-dom";
import { Match } from "@reach/router";
import { useViewer } from "components/viewer/context";
import Form from "pages/eligibility/components/context/form-data";

import { LoginModal } from "components/login";
import { getLayout, getSectionIndex } from "../helpers";
import FormLayout from "./form-layout";

interface Props {
  path?: string;
  section?: string;
}

const LoginPortal: React.FC<{isSignup?: boolean}> = ({ isSignup = false }) => {
  const element = document.querySelector("#login-modal");
  if (!element) throw new Error("Missing expected DOM elmement, unable to render login form.");

  return ReactDOM.createPortal(<LoginModal isSignup={isSignup}/>, element);
};

const AuthenticatedForm: React.FC<Props> = (props) => {
  const formData = React.useContext(Form);
  const viewer = useViewer();

  if (!formData) return null;
  const layout = getLayout(formData);
  const sectionIndex = getSectionIndex(props.section, layout);

  const [isSignup, setIsSignUp] = React.useState(false);
  const [isLogin, setIsLogin] = React.useState(false);

  useLayoutEffect(
    () => {
      const query = new URLSearchParams(window.location.search);
      const signup = query.get("is-signup");
      const login = query.get("is-login");

      setIsSignUp(signup === "true");
      setIsLogin(login === "true");
    }
    , [window.location.search],
  );


  return (
    <Match<{ submissionId: string }> path="/application/:submissionId/*">
      {(path) => (
        <>
          <FormLayout form={formData} section={props.section || ""} path={path} />
          {((viewer === null && sectionIndex >= 1) || isSignup || isLogin) && (
            <LoginPortal isSignup={isSignup} />)}
        </>
      )}
    </Match>
  );
};

export default AuthenticatedForm;
